module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/checkBack/nba/sirvive-e3e490c956e80f98fc45c0bc208820c4.svg";